import { useState } from 'react';
import { Pagination, Spin } from 'antd';
import { useRequest } from 'ahooks';
import { getBankAllTypePro } from '@/services/bank';
import BankCard from '@/components/ProductFilter/BankCard';
import './index.less';
import { EXCLUSIVE_PRODUCTS_TYPE } from '@/utils/mappingDict';

export default function Index() {
  const [list, setList] = useState({});
  const { run, loading } = useRequest((val = {}) => getBankAllTypePro({ ...val, bankTypeLists: EXCLUSIVE_PRODUCTS_TYPE }), { // 特惠产品
    onSuccess(res) {
      setList(res);
    },
  });

  function onChange(page, size) {
    run({ pageNum: page, pageSize: size });
  }

  return (
    <div className="special-offer">
      <div className="special-offer-banner">
        <div className="special-offer-banner__text">
          <div className="special-offer-banner__title">千亿级优势特色农业产业建圈强链产品专区</div>
          <div>
            千亿级优势特色农业产业建圈强链产品专区是四川省农业农村厅联合金融机构专门为农业企业以及相关农业产业链主体设计的一系列具有优惠性质的融资服务和产品，旨在满足农业生产经营者在生产、加工、销售等各个环节的资金需求，推动产业链全面发展。
          </div>
        </div>
      </div>
      <div className="special-offer__title">专区产品</div>
      <div className="content-width special-offer__list">
        <Spin spinning={loading}>
          {
            list?.items?.map((item) => (
              <BankCard data={item} key={item.productId} />
            ))
          }
        </Spin>
        <div className="pagination-box">
          <Pagination
            showQuickJumper
            current={list?.pageNum}
            total={list?.totalRows}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
}
